// Show types
export const POST_SHOW_RETRIEVED_SUCCESS = 'POST_SHOW_RETRIEVED_SUCCESS';
export const POST_SHOW_RESET = 'POST_SHOW_RESET';

// List types
export const POST_LIST_RESET = 'POST_LIST_RESET';
export const POST_LIST_VIEW = 'POST_LIST_VIEW';
export const POST_LIST_SUCCESS = 'POST_LIST_SUCCESS';
export const POST_LIST_SUCCESS_RESET = 'POST_LIST_SUCCESS_RESET';



// WEBPACK FOOTER //
// ./src/store/modules/post/mutation-types.js